/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Butter Thunk
 */

import Butter from './butter_bar.singleton'
import { removeButterBar, showButterBar } from './index'

export const ERROR_COLOR = 'error'
export const INFO_COLOR = 'info'
export const SUCCESS_COLOR = 'success'
export const WARNING_COLOR = 'warning'
export const BUTTER_DURATION_A11Y_COMPLIANT = 20000

const addButterBar = (dispatch, getState, butterBar) => {
  const butterBarId = Butter.getUniqueId()
  Object.assign(butterBar, {
    visible: true,
    bbId: butterBarId,
    duration: butterBar.duration || BUTTER_DURATION_A11Y_COMPLIANT,
    color: butterBar.color || ERROR_COLOR,
    removeHandler: () => {
      dispatch(removeButterBar(butterBarId))
    },
  })

  // timeout to allow any modal to close and bootstrap to shift page for scrollbar first #14593
  setTimeout(() => {
    dispatch(showButterBar(butterBar))
  }, 500)
  return butterBar
}

export const addSuccessButterBar = (butterBar) => {
  Object.assign(butterBar, { color: SUCCESS_COLOR })
  return (dispatch, getState) => {
    return addButterBar(dispatch, getState, butterBar)
  }
}

export const addErrorButterBar = (butterBar) => {
  Object.assign(butterBar, { color: ERROR_COLOR })
  return (dispatch, getState) => {
    return addButterBar(dispatch, getState, butterBar)
  }
}

export const addWarningButterBar = (butterBar) => {
  Object.assign(butterBar, { color: WARNING_COLOR })
  return (dispatch, getState) => {
    return addButterBar(dispatch, getState, butterBar)
  }
}

export const addInfoButterBar = (butterBar) => {
  Object.assign(butterBar, { color: INFO_COLOR })
  return (dispatch, getState) => {
    return addButterBar(dispatch, getState, butterBar)
  }
}

export const addNotifyButterBar = (butterBar) => {
  Object.assign(butterBar, { color: butterBar.color || ERROR_COLOR })
  return (dispatch, getState) => {
    return addButterBar(dispatch, getState, butterBar)
  }
}
